import React, { lazy, Suspense } from 'react';
import './Integration.scss';
const IntegrationsWorflowMicrofrontend = lazy(() =>
  import('./IntegrationsWorflowMicrofrontend').then((m) => ({ default: m.IntegrationsWorflowMicrofrontend }))
);

const IntegrationsWorflowMicrofrontendPage: React.FC = () => {
  return  <Suspense fallback={null}>
            <IntegrationsWorflowMicrofrontend />
          </Suspense>
};

export default IntegrationsWorflowMicrofrontendPage;
